import useId from '@mui/utils/useId';
import { useController } from 'react-hook-form';
import { useMemo } from 'react';

import BaseSelect from '@/components/BaseSelect';
import { executionRequirementShape } from '@/utils/transformFrontendCareGapAction';
import useGetUserFilters from '@/hooks/useGetUserFilters';
import FormErrorMessage from '@/components/FormErrorMessage';
import transformOption from '@/utils/transformOption';

import DynamicFormLabel from '../DynamicFormLabel';

const OTHER_PROVIDER_VALUE = 'other';

export default function DynamicFormOutsideProviderDropdown({ field }) {
  const { label, name } = field;
  const fieldId = useId();
  const { data, isLoading } = useGetUserFilters();

  const { providers = [] } = data || {};
  const options = useMemo(() => {
    const providerOptions = providers.map(transformOption);
    return [
      ...providerOptions,
      { value: OTHER_PROVIDER_VALUE, label: 'Other' },
    ];
  }, [providers]);

  const controller = useController({
    name,
    rules: {
      required: false,
    },
  });

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === OTHER_PROVIDER_VALUE) {
      controller.field.onChange('');
    } else {
      controller.field.onChange(selectedValue);
    }
  };

  const formValue = controller.field.value;
  const baseSelectValue = formValue === '' ? OTHER_PROVIDER_VALUE : formValue;

  return (
    !isLoading && (
      <>
        <DynamicFormLabel htmlFor={fieldId}>Provider</DynamicFormLabel>
        <BaseSelect
          id={fieldId}
          data-pendo-id={field.dataPendoId}
          fullWidth
          label={label}
          options={options}
          value={baseSelectValue}
          onChange={handleSelectChange}
        />
        <FormErrorMessage errors={controller.formState.errors} name={name} />
      </>
    )
  );
}

DynamicFormOutsideProviderDropdown.propTypes = {
  field: executionRequirementShape.isRequired,
};
